<script>
  import Breadcrumbs from '$components/Breadcrumbs/Breadcrumbs.svelte';
  import MastheadSearchPromo from '$components/MastheadSearchPromo/MastheadSearchPromo.svelte';
  import PharmacyLocations from '$components/PharmacyLocations/PharmacyLocations.svelte';
  import DrugSavingsList from '$components/DrugSavingsList/DrugSavingsList.svelte';
  import ExtendedPharmaciesList from '$components/ExtendedPharmaciesList/ExtendedPharmaciesList.svelte';

  let { data } = $props();

  const extendedPharmaciesCount = data.count > 6 ? data.count : 0;
</script>

<svelte:head>
  {#if data.pharmacyLocations.paginationControl && data.pharmacyLocations.paginationControl.prevLink}
    <link rel="prev" href={data.pharmacyLocations.paginationControl.prevLink} />
  {/if}
  {#if data.pharmacyLocations.paginationControl && data.pharmacyLocations.paginationControl.nextLink}
    <link rel="next" href={data.pharmacyLocations.paginationControl.nextLink} />
  {/if}
</svelte:head>

<Breadcrumbs crumbsText={data.crumbsText} path={data.path} paginationPage={data.paginationPage} />
<MastheadSearchPromo
  {...data.mastheadSearchPromo}
  filters={`'nationwide' OR '${data.stateName}' OR '${data.cityName}, ${data.stateAbbreviation.toUpperCase()}'`}
  lang={data.lang}
/>
<div class="py-6 md:py-8 mx-auto max-w-6xl lg:flex">
  <PharmacyLocations {...data.pharmacyLocations} pharmacies={data.pharmacies} fullWidth="true" />
</div>
<div class="px-4 pb-6 md:pb-8 mx-auto max-w-6xl">
  <DrugSavingsList {...data.drugSavingsList} />
</div>
{#if data.extendedPharmaciesList}
  <div
    class="bg-gray-mercury w-full py-8 lg:py-12 shadow-content-well"
    class:pt-0={extendedPharmaciesCount === 0}
    class:lg:pt-4={extendedPharmaciesCount === 0}
  >
    <ExtendedPharmaciesList
      {...data.extendedPharmaciesList}
      count={extendedPharmaciesCount}
      pharmacies={data.pharmacyChains}
    />
  </div>
{/if}
